
/**
 * Event/Analytics Tracker Config
 * Allows you to set multiple GA codes
 */
export class EventTrackerConfig {
  public primaryTrackingCode: string | undefined;
  public secondaryTrackingCode?: string;
}
